import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, withTheme } from '@rneui/themed';
import { ScrollView } from 'react-native-gesture-handler';
export const UnthemedDescriptionMask = ({ children, maxHeight = 150, containerStyle = {}, buttonStyle = {}, buttonTitleStyle = {}, showExpandButton = true, }) => {
    const [isMasked, setIsMasked] = useState(true);
    const [isExpanded, setIsExpanded] = useState(false);
    const isFull = !isMasked || isExpanded;
    return (React.createElement(View, { style: [containerStyle] },
        React.createElement(ScrollView, { scrollEnabled: isMasked && !showExpandButton, style: {
                maxHeight: !isFull ? maxHeight : undefined,
                overflow: 'hidden',
            }, onContentSizeChange: (_, height) => {
                setIsMasked(height + 1 >= maxHeight);
            } },
            React.createElement("div", { style: {
                    maxHeight: !isFull ? maxHeight : undefined,
                    ...(!isFull ? styles.mask : {}),
                } }, children)),
        isMasked && showExpandButton && (React.createElement(Button, { type: "clear", onPress: () => setIsExpanded(!isFull), buttonStyle: buttonStyle, titleStyle: buttonTitleStyle }, !isFull ? '+ Expand' : '- Collapse'))));
};
const styles = StyleSheet.create({
    mask: {
        overflow: 'hidden',
        WebkitMaskImage: 'linear-gradient(to bottom, white 50%, transparent 90%, transparent 100%)',
        maskImage: 'linear-gradient(to bottom, white 50%, transparent 90%, transparent 100%)',
    },
});
export const DescriptionMask = withTheme(UnthemedDescriptionMask, 'DescriptionMask');
//# sourceMappingURL=DescriptionMask.web.js.map